import { Injectable } from '@angular/core';

interface QueryParams {
  [key: string]: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class QueryParamsService {
  private queryParams: QueryParams = {};
  private validKeys = [
    'uuid',
    'id',
    'clientId',
    'returnUrl',
    'lufu',
    'gender',
    'height',
    'weight',
    'age',
    'ethnicity',
    'smokingState',
    'smokingNumberOfYears',
    'smokingCigarettesPerDay',
    'acq6Q1',
    'acq6Q2',
    'acq6Q3',
    'acq6Q4',
    'acq6Q5',
    'acq6Q6',
  ];

  // Method to set query parameters in the service
  storeQueryParams(params: QueryParams): void {
    Object.keys(params).forEach(key => {
      if (this.validKeys.includes(key)) {
        this.queryParams[key] = params[key];
      }
    })
  }

  // Return the query parameters
  getQueryParams(): QueryParams {
    return { ...this.queryParams };
  }

  hasReturnUrl(): boolean {
    const deepLink = this.queryParams.returnUrl
    return !!deepLink;
  }

  openReturnUrl(): void {
    const deepLink = this.queryParams.returnUrl;
    this.queryParams = {}
    if (deepLink) {
      const decodedDeeplink = atob(deepLink)
      window.open(decodedDeeplink, '_blank');

    }
  }
}
